
import { Base } from '../base-component';
import './article-podcast.component.scss';

export class ArticlePodcast extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/article-podcast/article-podcast.component.ts